import React, {useEffect, useState} from 'react';
import Title from '../../../../components/style-guide/title/Title';
import Input from '../../../../components/style-guide/form/input/Input';
import SearchIcon from '../../../../components/style-guide/icons/Search.icon';
import InlineBox from '../../../../components/style-guide/box/InlineBox';
import useMedia from '../../../../hooks/useMedia';
import clsx from 'clsx';
import {AppRouters} from '../../../../settings';
import {Link} from '@reach/router';
import _debounce from 'lodash/debounce';
import {connect} from 'react-redux';
import {searchReportsAction} from '../../store/my-reports.actions';

export const SearchBar = ({actions, showRequestBtn}) => {
  const mobileBreakPoint = useMedia(['(min-width: 520px) and (max-width: 680px)', '(max-width: 520px)'], ['sm', 'xs'], false);
  const [search, setSearchValue] = useState(undefined);
  const handleSearch = e => {
    setSearchValue(e.target.value)
  };

  useEffect(_debounce(() => {
    if (search !== undefined) actions.searchReports(search)
  }, 300), [search]);

  return (
    mobileBreakPoint ?
      <div className="p-2 text-left w-100 pb-1">
        <Title className="block mb-0 px-3 " color=" var(--primary)">MIS REPORTES</Title>
        <InlineBox className={clsx("p-2", {'flex-column': mobileBreakPoint === 'xs'})}>
          <Input className={clsx("m-0", {'w-100': mobileBreakPoint === 'xs'})} type="text"
                 prefixIcon={(<SearchIcon fontSize="small"/>)} prefixTop={9}
                 placeholder="Buscar ..." value={search} onChange={handleSearch}/>

          <Link to={AppRouters.newReport}
                className={clsx("btn btn-primary px-3 ml-auto ", {'mt-3': mobileBreakPoint === 'xs'})}>
            <span>Solicitar Reporte</span>
          </Link>
        </InlineBox>
      </div>
      :
      <InlineBox className="p-2 pb-4">
        <Title className="mb-0 px-3" color=" var(--primary)">MIS REPORTES</Title>
        <Input className="m-0" type="text" prefixIcon={(<SearchIcon fontSize="small"/>)} prefixTop={9}
               placeholder="Buscar ..." value={search} onChange={handleSearch}/>

        {
          showRequestBtn &&
          <Link to={AppRouters.newReport} className="btn btn-primary ml-auto mr-3 px-3">
            <span>Solicitar Reporte</span>
          </Link>
        }

      </InlineBox>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      searchReports: (payload) => dispatch(searchReportsAction(payload)),
    },
    dispatch
  }
};

export default connect(
  null,
  mapDispatchToProps
)(SearchBar);
